module.exports = __webpack_public_path__ + "static/img/应用场景6-历史作业.2b873e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-1/应用场景6-历史作业.png
// module id = 0B2J
// module chunks = 0